import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { ScrollingColumn } from 'foundations-components/transitional/components/ScrollingColumn';
import { useSelectHasScope } from '../context/XrayPanelContext';
import { useStandaloneTracker } from '../context/hooks';
import { TopicsGroupWrapper } from '../seo/topicsGroup/components/TopicsGroupWrapper';
import { CompletionStatuses } from '../constants';
import { SeoRecommendationGroups } from '../seo/constants';
import { getGroupIncompleteCount } from '../utils/auditResultsUtils';
import { GroupView } from '../seo/sharedComponents/GroupView';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const SectionView = ({
  auditResults,
  config,
  artifacts,
  contentId
}) => {
  const {
    recommendations
  } = config;
  const hasTopicClustersAccess = useSelectHasScope('topic-clusters-access');
  const {
    track
  } = useStandaloneTracker();
  useEffect(() => {
    track('xray-panel', 'page view', Object.assign({
      screen: 'page-editor'
    }, config.isContentStagingV2 && {
      subscreen: 'staged-pages-v2'
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const groupedRecommendations = recommendations.reduce((groupedRecs, rec) => {
    const groupType = rec.groupBy;
    if (config.isContentStagingV2 && groupType === SeoRecommendationGroups.TOPICS) {
      return groupedRecs;
    }
    const recs = groupedRecs[groupType] || [];
    if (rec.view) {
      recs.push(rec);
    }
    return Object.assign({}, groupedRecs, {
      [groupType]: recs
    });
  }, {});
  return /*#__PURE__*/_jsxs(ScrollingColumn, {
    children: [hasTopicClustersAccess && (config.isContentStagingV2 ? /*#__PURE__*/_jsx(Alert, {
      use: "inline",
      type: "info",
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "xray-recommendation-lib.seo.topicEditor.topicsUnavailableForStagedPages"
      })
    }) : /*#__PURE__*/_jsx(TopicsGroupWrapper, {
      contentId: contentId,
      artifacts: artifacts
    })), Object.entries(groupedRecommendations).map(group => {
      const [groupType, groupRecs] = group;
      const incompleteCount = getGroupIncompleteCount({
        auditResults,
        groupRecs
      });
      const recViews = [];
      for (const rec of groupRecs) {
        if (rec.view) {
          const RecommendationViewComponent = rec.view;
          const recAuditResult = auditResults[rec.type];
          if (recAuditResult && recAuditResult.status !== CompletionStatuses.NOT_APPLICABLE) {
            recViews.push( /*#__PURE__*/_jsx(RecommendationViewComponent
            // @ts-ignore TS can't identify if this rec has a valid view component
            , {
              // @ts-ignore TS can't identify which audit result shape should be applied to this rec
              auditResult: recAuditResult
              // @ts-ignore TS can't identify which editorApi should be applied to this rec
              ,
              editorApi: config.editorApi
              // @ts-ignore TS can't identify which contentId should be applied to this rec
              ,
              contentId: contentId
            }, rec.type));
          }
        }
      }
      if (recViews.length === 0) {
        return null;
      }
      return /*#__PURE__*/_jsx(GroupView, {
        groupType: groupType,
        incompleteCount: incompleteCount,
        children: recViews
      }, groupType);
    })]
  });
};